import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

import { computed } from "vue";
import phone from "./components/phone.vue";
import { PhoneModule } from "@/store/modules/Phone";
import PinPhone from "@/callcenter/components/PinPhone.vue";

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

//import phone from "./index.js";
const key = computed(() => PhoneModule.getKey);


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(), _createElementBlock("div", {
      key: _unref(key),
      class: ""
    }, [
      _createVNode(phone)
    ])),
    _createVNode(PinPhone, {
      type: "default",
      hideLabel: true,
      pinToBottom: true
    })
  ], 64))
}
}

})